/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const CommonSavedFilterResponseDTOTypeEnum = {
    Keyword: 'KEYWORD',
    Store: 'STORE',
    Search: 'SEARCH',
    ProductStaging: 'PRODUCT_STAGING',
    Inventory: 'INVENTORY'
};
/**
 * @export
 */
export const CommonSavedFilterResponseDTOTargetMarketEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const CommonSavedFilterResponseDTOAutoDeletePausedReasonEnum = {
    CandidateJump: 'CANDIDATE_JUMP',
    CandidateCeiling: 'CANDIDATE_CEILING'
};
/**
 * Check if a given object implements the CommonSavedFilterResponseDTO interface.
 */
export function instanceOfCommonSavedFilterResponseDTO(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
export function CommonSavedFilterResponseDTOFromJSON(json) {
    return CommonSavedFilterResponseDTOFromJSONTyped(json, false);
}
export function CommonSavedFilterResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'type': json['type'] == null ? undefined : json['type'],
        'targetMarket': json['targetMarket'] == null ? undefined : json['targetMarket'],
        'filter': json['filter'] == null ? undefined : json['filter'],
        'autoDelete': json['autoDelete'] == null ? undefined : json['autoDelete'],
        'periodHoursDelete': json['periodHoursDelete'] == null ? undefined : json['periodHoursDelete'],
        'maxProductsPerRunDelete': json['maxProductsPerRunDelete'] == null ? undefined : json['maxProductsPerRunDelete'],
        'lastDeleteRunAt': json['lastDeleteRunAt'] == null ? undefined : (new Date(json['lastDeleteRunAt'])),
        'lastDeleteFoundCount': json['lastDeleteFoundCount'] == null ? undefined : json['lastDeleteFoundCount'],
        'lastDeleteInventoryCount': json['lastDeleteInventoryCount'] == null ? undefined : json['lastDeleteInventoryCount'],
        'autoDeletePausedAt': json['autoDeletePausedAt'] == null ? undefined : (new Date(json['autoDeletePausedAt'])),
        'autoDeletePausedReason': json['autoDeletePausedReason'] == null ? undefined : json['autoDeletePausedReason'],
        'autoAddToInventory': json['autoAddToInventory'] == null ? undefined : json['autoAddToInventory'],
        'periodHoursAdd': json['periodHoursAdd'] == null ? undefined : json['periodHoursAdd'],
        'maxProductsPerRunAdd': json['maxProductsPerRunAdd'] == null ? undefined : json['maxProductsPerRunAdd'],
        'lastAddRunAt': json['lastAddRunAt'] == null ? undefined : (new Date(json['lastAddRunAt'])),
        'autoAddToProductStaging': json['autoAddToProductStaging'] == null ? undefined : json['autoAddToProductStaging'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'lastModifiedBy': json['lastModifiedBy'] == null ? undefined : json['lastModifiedBy'],
        'lastModifiedDate': json['lastModifiedDate'] == null ? undefined : (new Date(json['lastModifiedDate'])),
    };
}
export function CommonSavedFilterResponseDTOToJSON(json) {
    return CommonSavedFilterResponseDTOToJSONTyped(json, false);
}
export function CommonSavedFilterResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'type': value['type'],
        'targetMarket': value['targetMarket'],
        'filter': value['filter'],
        'autoDelete': value['autoDelete'],
        'periodHoursDelete': value['periodHoursDelete'],
        'maxProductsPerRunDelete': value['maxProductsPerRunDelete'],
        'lastDeleteRunAt': value['lastDeleteRunAt'] == null ? undefined : ((value['lastDeleteRunAt']).toISOString()),
        'lastDeleteFoundCount': value['lastDeleteFoundCount'],
        'lastDeleteInventoryCount': value['lastDeleteInventoryCount'],
        'autoDeletePausedAt': value['autoDeletePausedAt'] == null ? undefined : ((value['autoDeletePausedAt']).toISOString()),
        'autoDeletePausedReason': value['autoDeletePausedReason'],
        'autoAddToInventory': value['autoAddToInventory'],
        'periodHoursAdd': value['periodHoursAdd'],
        'maxProductsPerRunAdd': value['maxProductsPerRunAdd'],
        'lastAddRunAt': value['lastAddRunAt'] == null ? undefined : ((value['lastAddRunAt']).toISOString()),
        'autoAddToProductStaging': value['autoAddToProductStaging'],
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'lastModifiedBy': value['lastModifiedBy'],
        'lastModifiedDate': value['lastModifiedDate'] == null ? undefined : ((value['lastModifiedDate']).toISOString()),
    };
}
